/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import { useTranslation } from "react-i18next";

interface Props {
	batchInfo?: {
		totalPlatesEligible: number;
	};
	goBack: () => void;
}
const ESSuccessView = ({ batchInfo, goBack }: Props) => {
	const { t } = useTranslation();
	return (
		<div className="flex flex-col items-center justify-center h-full bg-[#F8FAFC] p-8 animate-in fade-in duration-500">
			<div className="bg-white rounded-[40px] shadow-2xl p-16 text-center max-w-2xl border border-slate-100">
				<div className="w-24 h-24 bg-emerald-50 rounded-full flex items-center justify-center mx-auto mb-8 border border-emerald-100">
					<span className="material-symbols-outlined text-emerald-500 text-6xl">
						check_circle
					</span>
				</div>
				<h2 className="text-3xl font-black text-[#1E293B] mb-4 tracking-tight">
					{t("postAutoclaveProcess.emptySterilization.sterilizatoinSuccessTitle")}
				</h2>
				<p className="text-slate-500 font-medium text-lg mb-10 leading-relaxed">
					{batchInfo?.totalPlatesEligible} {t("postAutoclaveProcess.emptySterilization.sterilizationSuccessMessage")}
				</p>
				<div className="flex gap-4 justify-center">
					{/* <button className="px-10 py-4 bg-white border border-slate-200 rounded-2xl text-[11px] font-black text-slate-500 uppercase tracking-widest hover:bg-slate-50 transition-all">
						{t("postAutoclaveProcess.emptySterilization.viewInventoryBtn")}
					</button> */}
					<button onClick={goBack} className="px-10 py-4 bg-[#2D3E50] text-white rounded-2xl text-[11px] font-black uppercase tracking-widest shadow-xl shadow-slate-200 hover:bg-slate-800 transition-all">
						{t("postAutoclaveProcess.emptySterilization.returnToBatchList")}
					</button>
				</div>
			</div>
		</div>
	);
};

export default ESSuccessView;
